<template>
    <div class="wtc_setCardPosition-table">
        <ul class="wtc_setCardPosition-table-header">
            <li class="wtc_setCardPosition-table-header-item">{{langMsg.workTime}}</li>
            <li class="wtc_setCardPosition-table-header-item">{{langMsg.startTimeCard}}</li>
            <li class="wtc_setCardPosition-table-header-item">{{langMsg.endTimeCard}}</li>
            <li class="wtc_setCardPosition-table-header-item">{{langMsg.isopenvalid}}</li>
        </ul>
        <div class="wtc_setCardPosition-table-body">
            <ul class="wtc_setCardPosition-table-body-row" v-for="(item, index) in cardData" :key="index">
                <li class="wtc_setCardPosition-table-body-col wtc_setCardPosition-table-body-col-text" :title="item.time.value" :style="{background: index%2===1 ? '#f5f6f7' : '#fff'}">{{item.time.value}}</li>
                <li class="wtc_setCardPosition-table-body-col" :style="{background: index%2===1 ? '#f5f6f7' : '#fff'}">
                    <div class="wtc_setCardPosition-table-body-btn" @mouseenter="showMessage(item.isworktimestart.disable, item.isworktimestart.value, $event)" @mouseleave="hideMessage(item.isworktimestart.disable, item.isworktimestart.value)" @click="btnClick(item.isworktimestart.index)" :class="{'wtc_setCardPosition-btn-hidden': item.isworktimestart.value==0, 'wtc_setCardPosition-btn-close': item.isworktimestart.value==2, 'wtc_setCardPosition-btn-open': item.isworktimestart.value==1, 'wtc_setCardPosition-btn-disable': item.isworktimestart.disable}" :index="item.isworktimestart.index">
                        <div class="wtc_setCardPosition-table-body-btn-inner"></div>
                        <!--<div class="wtc_setCardPosition-table-body-btn-pop" v-if="item.isworktimestart.disable && item.isworktimestart.value==2">{{langMsg.message}}</div>-->
                    </div>
                </li>
                <li class="wtc_setCardPosition-table-body-col" :style="{background: index%2===1 ? '#f5f6f7' : '#fff'}">
                    <div class="wtc_setCardPosition-table-body-btn" @mouseenter="showMessage(item.isworktimeend.disable, item.isworktimeend.value, $event)" @mouseleave="hideMessage(item.isworktimeend.disable, item.isworktimeend.value)" @click="btnClick(item.isworktimeend.index)" :class="{'wtc_setCardPosition-btn-hidden': item.isworktimeend.value==0, 'wtc_setCardPosition-btn-close': item.isworktimeend.value==2, 'wtc_setCardPosition-btn-open': item.isworktimeend.value==1, 'wtc_setCardPosition-btn-disable': item.isworktimeend.disable}" :index="item.isworktimeend.index">
                        <div class="wtc_setCardPosition-table-body-btn-inner"></div>
                        <!--<div class="wtc_setCardPosition-table-body-btn-pop" v-if="item.isworktimeend.disable && item.isworktimeend.value==2">{{langMsg.message}}</div>-->
                    </div>
                </li>
                <li class="wtc_setCardPosition-table-body-col" :style="{background: index%2===1 ? '#f5f6f7' : '#fff'}">
                    <div class="wtc_setCardPosition-table-body-btn" @mouseenter="showMessage(item.isopenvalid.disable, item.isopenvalid.value, $event)" @mouseleave="hideMessage(item.isopenvalid.disable, item.isopenvalid.value)" @click="btnClick(item.isopenvalid.index)" :class="{'wtc_setCardPosition-btn-hidden': item.isopenvalid.value==0, 'wtc_setCardPosition-btn-close': item.isopenvalid.value==2, 'wtc_setCardPosition-btn-open': item.isopenvalid.value==1, 'wtc_setCardPosition-btn-disable': item.isopenvalid.disable}" :index="item.isopenvalid.index">
                        <div class="wtc_setCardPosition-table-body-btn-inner"></div>
                        <!--<div class="wtc_setCardPosition-table-body-btn-pop" v-if="item.isopenvalid.disable && item.isopenvalid.value==2">{{langMsg.message}}</div>-->
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cardData: {
                type: Array,
                default: [],
            },
            langMsg: {
                type: Object,
                default: {},
            }
        },
        mounted(){
            // console.log(this.cardData);
        },
        methods: {
            btnClick(index) {
                for(let i = 0; i < this.cardData.length; i++) {
                    if(this.cardData[i].isworktimestart.index === index) {
                        if(!this.cardData[i].isworktimestart.disable) {
                            this.cardData[i].isworktimestart.value = this.cardData[i].isworktimestart.value == '1' ? '2' : '1';
                            this.$emit('clickBtn', this.cardData[i].isworktimestart);
                        }
                        break;
                    }
                    if(this.cardData[i].isworktimeend.index === index) {
                        if(!this.cardData[i].isworktimeend.disable) {
                            this.cardData[i].isworktimeend.value = this.cardData[i].isworktimeend.value == '1' ? '2' : '1';
                            this.$emit('clickBtn', this.cardData[i].isworktimeend);
                        }
                        break;
                    }
                    if(this.cardData[i].isopenvalid.index === index) {
                        if(!this.cardData[i].isopenvalid.disable) {
                            this.cardData[i].isopenvalid.value = this.cardData[i].isopenvalid.value == '1' ? '2' : '1';
                            this.$emit('clickBtn', this.cardData[i].isopenvalid);
                        }
                        break;
                    }
                }
            },
            showMessage(disable, value, event) {
                if(disable && value == 2) {
                    let $this = this;
                    $this.$root.myTool.popover_isEnter = true;
                    setTimeout(function () {
                        if ($this.$root.myTool.popover_isEnter && !document.querySelector('.wtc_kztTool_popover-wrap')) {
                            $this.$root.myTool.popover({
                                positionX: event.clientX,
                                positionY: event.clientY,
                                isHtml:false,
                                data: $this.langMsg.message,  // 当isHtml为true时，则data传HTML数据；否则传具体字符串
                                callback: function(){}
                            })
                        }
                    }, 100);
                }
            },
            hideMessage(disable, value) {
                if(disable && value == 2) {
                    let $this = this;
                    this.$root.myTool.popover_isEnter = false;
                    setTimeout(function () {
                        if (!$this.$root.myTool.popover_isEnter) {
                            var pop = document.querySelector('.wtc_kztTool_popover-wrap');
                            pop && document.querySelector('body').removeChild(pop);
                        }
                    }, 100);
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    /*@import '../css/variables.less';*/

    .wtc_setCardPosition-table {
        border-left: 1px solid #d9d9d9;
        font-size: 14px;
        color: #333;
        background-color: #fff;
    }

    .wtc_setCardPosition-table .wtc_setCardPosition-table-header {
        display: flex;
        height: 40px;
        line-height: 40px;
    }
    .wtc_setCardPosition-table-header .wtc_setCardPosition-table-header-item{
        flex: 0 0 200px;
        text-align: center;
        border-bottom: 1px solid #d9d9d9;
        border-right: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
    }

    .wtc_setCardPosition-table-body .wtc_setCardPosition-table-body-row{
        display: flex;
        height: 40px;
    }
    .wtc_setCardPosition-table-body .wtc_setCardPosition-table-body-row .wtc_setCardPosition-table-body-col{
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 200px;
        text-align: center;
        border-bottom: 1px solid #d9d9d9;
        border-right: 1px solid #d9d9d9;
    }
    .wtc_setCardPosition-table-body-row .wtc_setCardPosition-table-body-col-text {
        text-overflow: clip;
        overflow: hidden;
        white-space: nowrap;
    }
    .wtc_setCardPosition-table-body-row .wtc_setCardPosition-table-body-col .wtc_setCardPosition-table-body-btn {
        position: relative;
        width: 60px;
        height: 24px;
        border-radius: 12px;
        padding: 2px;
        box-sizing: border-box;
    }
    /*.wtc_setCardPosition-table-body-row .wtc_setCardPosition-table-body-btn:hover .wtc_setCardPosition-table-body-btn-pop {*/
        /*display: block;*/
    /*}*/
    .wtc_setCardPosition-table-body-btn .wtc_setCardPosition-table-body-btn-inner {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
    }
    /*.wtc_setCardPosition-table-body-btn .wtc_setCardPosition-table-body-btn-pop {*/
        /*display: none;*/
        /*position: absolute;*/
        /*left: 20px;*/
        /*top: 24px;*/
        /*padding: 12px;*/
        /*width: 210px;*/
        /*box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);*/
        /*z-index: 2;*/
        /*background-color: #fff;*/
        /*color: #666;*/
        /*border-radius: 4px;*/
        /*text-align: left;*/
        /*cursor: auto;*/
    /*}*/

    .wtc_setCardPosition-btn-hidden {
        display: none;
    }
    .wtc_setCardPosition-btn-close{
        background-color: #bbb;
        cursor: pointer;
    }
    .wtc_setCardPosition-btn-open {
        background-color: var(--themeColor, #276FF5);
        cursor: pointer;
    }
    .wtc_setCardPosition-btn-close .wtc_setCardPosition-table-body-btn-inner{
        float: left;
    }
    .wtc_setCardPosition-btn-open .wtc_setCardPosition-table-body-btn-inner{
        float: right;
    }
    .wtc_setCardPosition-btn-disable {
        cursor: not-allowed;
    }
</style>
